// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"240":"f890011a","268":"4e8b1af2","379":"53f0a314","424":"effe3cd0","488":"83d89e22","524":"9df5a88e","561":"7299bfd8","589":"81aca647","591":"0b1a062b","775":"d09100b0","806":"3730734f","824":"27aeb28b"}[chunkId] + ".chunk.js";
};